/**
 * Remote image → a JPEG data URL jsPDF can embed, plus its pixel size.
 *
 * Fetched with CORS (the MinIO media host echoes the page origin), drawn
 * onto a canvas over white — PNG transparency would print black — and
 * scaled down to MAX_EDGE so a 12-megapixel phone photo doesn't bloat the
 * PDF. Resolves null instead of throwing (dead link, 403 legacy /storage
 * URL, an undecodable format): the report then lists that photo by name.
 */

const MAX_EDGE = 1400

export async function loadImage(url) {
  try {
    const res = await fetch(url, { mode: 'cors', credentials: 'omit' })
    if (!res.ok) return null
    const blob = await res.blob()
    if (!blob.type.startsWith('image/')) return null

    const bitmap = await createImageBitmap(blob)
    const scale = Math.min(1, MAX_EDGE / Math.max(bitmap.width, bitmap.height))
    const width = Math.max(1, Math.round(bitmap.width * scale))
    const height = Math.max(1, Math.round(bitmap.height * scale))

    const canvas = document.createElement('canvas')
    canvas.width = width
    canvas.height = height
    const ctx = canvas.getContext('2d')
    ctx.fillStyle = '#ffffff'
    ctx.fillRect(0, 0, width, height)
    ctx.drawImage(bitmap, 0, 0, width, height)
    bitmap.close?.()

    return { dataUrl: canvas.toDataURL('image/jpeg', 0.85), width, height }
  } catch {
    return null
  }
}
